/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /*
     | Script to make dropdowns work on the site.
     */

    //
    $('button[aria-expanded="true"]').click((e) => {
        e.preventDefault();

        $('div[role="menu"]').toggleClass('hidden');
    });
});
